const WalrusComp = ({ changeColor }) => {
  return (
    <svg viewBox="0 0 510.18 465.4">
      <defs>
        {/* <style>
          {
            ".prefix__cls-1,.prefix__cls-2{fill:#ab8c85}
            .prefix__cls-1,.prefix__cls-2,.prefix__cls-3,.prefix__cls-4{stroke:#231f20;stroke-miterlimit:10}
            .prefix__cls-1,.prefix__cls-3{stroke-width:1.02px}
            .prefix__cls-2,.prefix__cls-4{stroke-width:1.03px}
            .prefix__cls-3{fill:#baabd3}
            .prefix__cls-4{fill:#fff}"
          }
        </style> */}
      </defs>
      <g id="prefix__Layer_2" data-name="Layer 2">
        <g id="prefix__Layer_1-2" data-name="Layer 1">
          <path
            // className="prefix__cls-1"
            d="M364.35 237.06c-20.15-11.28 41-35 62-20s8 41 5 45c32-8 74-15 78 10s-29 53-72.5 39c-19.5-2-61.28 67.83-61.28 67.83 15-45 13.78-127.83-11.22-141.83z"
            onClick={changeColor}
            fill="#ab8c85"
            stroke="#231f20"
            strokeMiterlimit={10}
            className="tail"
            id="tail"
          />
          <path
            // className="prefix__cls-2"
            d="M164.87 267.36l-41.62-27.7S-27.55 269.51 5.16 353.92s124.75-21.38 156.84-82.3z"
            onClick={changeColor}
            fill="#ab8c85"
            stroke="#231f20"
            strokeMiterlimit={10}
            className="flipper"
            id="flipper"
          />
          <path
            // className="prefix__cls-1"
            d="M274.57 124.89c91.35 15 142.16 220.19 101 254-49 40.25-175 68-241 13-21.36-17.8-67.06-301 140-267z"
            onClick={changeColor}
            fill="#ab8c85"
            stroke="#231f20"
            strokeMiterlimit={10}
            className="body"
            id="body"
          />
          <path
            // className="prefix__cls-3"
            d="M287.65 53.11c63.5 9.18 81.63 122 80.6 128 19.64 13 11.37 50 11.37 50-27.9 22-242.85-33-255.25-46-5.16-22 15.5-49 22.74-51-3.11-27 50.63-94 140.54-81zM156.35 138.11c33 20 169 48 198 43"
            onClick={changeColor}
            fill="#baabd3"
            stroke="#231f20"
            strokeMiterlimit={10}
            className="hat"
            id="hat"
          />
          <circle
            // className="prefix__cls-3"
            cx={276.41}
            cy={51.46}
            r={50.95}
            onClick={changeColor}
            fill="#baabd3"
            stroke="#231f20"
            strokeMiterlimit={10}
            className="pompom"
            id="pompom"
          />
          <path
            // className="prefix__cls-2"
            d="M300.67 292.89h50s109 108.4 35 160.55-92-86.92-85-155.44z"
            onClick={changeColor}
            fill="#ab8c85"
            stroke="#231f20"
            strokeMiterlimit={10}
            className="flipper"
            id="filpper"
          />
          <path
            // className="prefix__cls-4"
            d="M161.76 323.31l32.45 4.18c-8.77 27.4-3.51 96.7 0 102.84-9.65 4.12-17.32.81-24-10.56s-8.45-96.46-8.45-96.46zM248.06 327.49l-32.46 4.18c8.77 27.4 3.51 96.7 0 102.84 9.65 4.12 17.32.81 24-10.56s8.46-96.46 8.46-96.46z"
            onClick={changeColor}
            fill="#fff"
            stroke="#231f20"
            strokeMiterlimit={10}
            className="tusk"
            id="tusk"
          />
          <path
            // className="prefix__cls-4"
            d="M211.76 268.05c28.94 3.51 70.17 33.79 64 59.44S241.58 367.17 203 339.1c-36.84 14-67.54-19.3-52.63-47.37s61.39-23.68 61.39-23.68z"
            onClick={changeColor}
            fill="#fff"
            stroke="#231f20"
            strokeMiterlimit={10}
            className="nose"
            id="nose"
          />
        </g>
      </g>
    </svg>
  );
};

export default WalrusComp;
